import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BellRing, Loader2, LogIn, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Ministro alert: who joined/left the court of this matter, with the newcomer's Fidem profile
export const MatterCourtAlerts = ({ matter, onUpdated }) => {
  const { api } = useAuth();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const unread = matter.court_alerts_unread || 0;
  if (!('court_alerts_unread' in matter)) return null;
  const open = async () => {
    if (items) { setItems(null); return; }
    setBusy(true);
    try {
      const r = await api.get(`/courts/alerts/${matter.id}`);
      setItems(r.data.alerts);
      if (unread) { await api.post(`/courts/alerts/${matter.id}/read`); onUpdated(); }
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-2">
      <button data-testid={`matter-court-alerts-btn-${matter.id}`} onClick={open} className={`flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs transition-colors ${unread ? 'border-rose-500/60 bg-rose-500/10 text-rose-200' : 'border-slate-700 text-slate-400 hover:text-white'}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <BellRing className="h-3 w-3" />}
        {unread ? `${unread} cambio(s) en la integración del tribunal` : 'Historial de cambios del tribunal'}
      </button>
      {items && (
        <div data-testid={`matter-court-alerts-${matter.id}`} className="mt-2 space-y-2">
          {!items.length && <p className="text-xs text-slate-500">Sin cambios registrados.</p>}
          {items.map((a) => (
            <div key={a.id} data-testid={`court-alert-${a.id}`} className={`rounded-xl border p-3 text-xs ${a.kind === 'llega' ? 'border-emerald-500/30 bg-emerald-500/5' : 'border-rose-500/30 bg-rose-500/5'}`}>
              <p className="flex items-center gap-1.5 font-semibold text-white">
                {a.kind === 'llega' ? <LogIn className="h-3.5 w-3.5 text-emerald-300" /> : <LogOut className="h-3.5 w-3.5 text-rose-300" />}
                {a.kind === 'llega' ? 'Llega' : 'Sale'} {a.fiscal ? 'el fiscal judicial' : `${/^(ministra|jueza|presidenta)/i.test(a.position || '') ? 'la' : 'el'} ${a.position || 'magistrado'}`} {a.judge_id ? <Link to={`/jueces/${a.judge_id}`} className="text-amber-300 hover:underline">{a.judge_name}</Link> : <span className="text-amber-300">{a.judge_name}</span>}
              </p>
              <p className="mt-0.5 text-slate-400">{a.court_name} · {new Date(a.created_at).toLocaleDateString('es-CL')}{a.is_assigned ? (a.kind === 'sale' ? ' · era tu magistrado asignado' : ' · es tu magistrado asignado') : ''}{a.emailed === false ? ' · correo no enviado' : a.emailed ? ' · avisado por correo' : ''}</p>
              {a.profile?.estilo && <p className="mt-1 line-clamp-3 text-slate-300">Estilo {a.profile.estilo}. {a.profile.resumen} <b>Cómo ganar:</b> {[].concat(a.profile.como_ganar || []).join(' · ')}</p>}
              {a.profile?.estilo && <Link to={`/jueces/${a.judge_id}`} data-testid={`court-alert-profile-${a.id}`} className="text-[11px] text-amber-300 hover:underline">Ver perfil completo</Link>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
